export const getApiURL = () => process.env.REACT_APP_URL_API;